import { Partner } from 'src/types';
import { inIframe } from './browser';
import { ExchangeType } from 'src/data';

/**
 * Helper function for special logic to handoff to freelancers union
 * We should only handoff in NYC counties when partner is specified and we're in an iframe
 * @param param0
 * @returns
 */
export function shouldHandoffToFreelancersUnion({
  fips,
  partner,
}: {
  fips: string;
  partner: string;
}) {
  const EXCLUDED_FIPS = ['36061', '36005', '36047', '36081', '36085'];
  return EXCLUDED_FIPS.includes(fips) && partner === Partner.FreelancersUnion && inIframe();
}

/**
 * Note: extend the ICHRA partner logic here if we want to
 */
export function isIchraPartner({ partner }: { partner?: string }) {
  const ICHRA_PARTNERS = [Partner.Decisely];
  return ICHRA_PARTNERS.includes(partner as Partner);
}

/**
 * Only show off exchange details for ICHRA partners
 * - Currently, flagged to only show in dev
 */
export function shouldShowOffExchange({
  partner
}: { partner?: string }) {
  return isIchraPartner({ partner });
}

/**
 * Gets the default exchange type based on partner
 */
export function getDefaultExchangeType({ partner }: { partner?: string }) {
  return shouldShowOffExchange({ partner }) ? ExchangeType.OffMarket : ExchangeType.OnMarket;
}